export enum EEquipmentType {
    intercomKey = 'elektronnyy-klyuch',
}
